<template>
  <div class="day-selection flex items-center my-4">
    <span
      class="title mr-4"
      @click.prevent="toggleSelection"
      :class="{ active: repeat.isActivated }"
      v-if="!!title"
    >
      {{ title }}
    </span>
  </div>
</template>

<script>
export default {
  props: ["title", "isAllDay", "repeat"],
  computed: {
    showSetting() {
      const hasTitle = !!this.title;

      // when has title, only show if avtivated,
      // otherwise always show setting box.

      return hasTitle ? this.repeat.isActivated : true;
    }
  },
  methods: {
    toggleSelection() {
      this.$set(this.repeat, "isActivated", !this.repeat.isActivated);
    },

    getLocationStyleClass() {
      return this.isAllDay ? "md-size-70" : "md-size-30";
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: #3c4858;
  background: #c4c4c4;

  font-weight: 500;
  text-transform: capitalize;
  text-align: center;
  line-height: 40px;

  cursor: pointer;
  transition: 0.15s;

  &:hover {
    background: rgba(#4caf50, 0.3);
    color: white;
  }

  &.active {
    background: #4caf50;
    color: white;
  }
}
</style>
